<div [formGroup]="formArray.controls[group]" id="devices">
    <targeting-container label="Devices" labelSectionWidth="150px" (onEdit)="openSidebar()" (onRemove)="reset()"
        [disabled]="isDisabled">
        <div class="d-inline-block" [class.disabled]="isDisabled">
            <span class="chip-container" [ngClass]="isDisabled ? 'hide-chip-close-button' : 'cursor-pointer'"
                *ngFor="let item of selectedDevices;">
                <acl-ngx-chip [text]="item.id" (close)="removeDevice(item)" [disabled]="isDisabled">
                </acl-ngx-chip>
            </span>
            <span class="font-italic py-1">
                <span (click)="openSidebar()" [ngClass]="isDisabled ? 'disabled' : 'cursor-pointer'">Select</span>
            </span>
        </div>
    </targeting-container>
    <acl-ngx-flyout [open]="open" (close)="cancel()" large="true" portalRoot="devices">
        <acl-ngx-flyout-header title="Devices" (close)="cancel()">
        </acl-ngx-flyout-header>
        <acl-ngx-flyout-body>
            <browse-and-select [selectedTableNullStateText]="selectedTableNullStateText" [data]="originalDevices"
                [hidden]="!open" [preSelectedData]="preSelectedDevices" [settings]="settings"
                (onDataChange)="onDataChange($event)" (onFilterChange)="onFilterChange($event)">
            </browse-and-select>
        </acl-ngx-flyout-body>
        <acl-ngx-flyout-footer [leftButton]="saveButton" [rightButton]="cancelButton"></acl-ngx-flyout-footer>
    </acl-ngx-flyout>
</div>